<template>
    <div>
        <div class="outer-bar">
            <div class="inner-bar" v-bind:style="{width: calcPercent() + '%'}"></div>
        </div>
        <div align="center" v-if="showValue">
            {{ currentValue }} / {{ maxValue }} {{ unit }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProgressBar',
        components: {},
        props: {
            showValue: {
                type: Boolean,
                default: true,
            },
            maxValue: {
                type: Number,
                default: 100,
            },
            currentValue: {
                type: Number,
                default: 50,
            },
            unit: {
                type: String,
                default: '%',
            },
        },
        methods: {
            calcPercent () {
                if (this.currentValue >= this.maxValue) {
                    return 100;
                }

                return ((this.currentValue * 100) / this.maxValue).toFixed(2);
            },
        },
    };
</script>

<style scoped>
    .outer-bar {
        width: 100%;
        border: 1px solid lightgrey;
        height: 40px;
        border-radius: 5px;
    }

    .inner-bar {
        width: 30%;
        border-radius: inherit;
        height: 38px;

        background: url('https://cdn.gemeindeplaner.at/pv-wimsbach/chalk.png') no-repeat;
        background-size: cover;
    }
</style>
